var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.059 4.96181C16.5553 4.96181 16.082 5.07952 15.6683 5.28747C15.2698 3.96835 13.5521 3 12.0118 3C10.4715 3 8.7319 3.96835 8.33253 5.28747C7.91886 5.07952 7.44551 4.96181 6.94356 4.96181C5.3175 4.96181 4 6.19147 4 7.70834C4 9.22522 5.26033 10.4549 6.94188 10.4549V21H17.0312V10.4549C18.7128 10.4549 20 9.22522 20 7.70834C20 6.19147 18.6833 4.96181 17.059 4.96181Z",
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94141 17.8611H17.0307",
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChef);
export default __webpack_public_path__ + "static/media/icon-chef.41ed40625e2c03fb903f212b48d24a77.svg";
export { ForwardRef as ReactComponent };